<template>
    <div
        v-if="!area.deleted"
        class="px-4 py-2 border border-gray-100 hover:bg-gray-50 rounded shadow-sm hover:shadow transition duration-150 flex items-center justify-between font-mono"
    >
        <modal @close="closeDeleteModal" :closable="!deleting" :open="deleteModalOpen">
            <div slot="header">
                <h2 class="pt-2 text-xl font-semibold text-red-600">
                    Delete Area
                </h2>
            </div>
            <div slot="content">
                <form class="mt-4" @submit.prevent="deleteArea">
                    <p class="bg-red-100 rounded-sm px-3 py-4">
                        Are you sure you want to delete area area id.
                        <br />
                        <span class="uppercase tracking-wide text-sm font-medium"
                            >This action cannot be reversed!!</span
                        >
                    </p>
                    <p v-if="!!deleteError" class="my-2 error-msg">{{ deleteError }}</p>
                    <div class="px-2 mt-6 mb-2 flex justify-between">
                        <Button
                            :disabled="deleting"
                            @click="closeDeleteModal"
                            class="bg-gray-200 hover:bg-white hover:border-gray-800 border border-transparent px-6 py-2 rounded"
                            type="button"
                            label="Cancel"
                        />
                        <Button
                            :disabled="deleting"
                            :loading="deleting"
                            class="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded"
                            label="Yes Delete"
                        />
                    </div>
                </form>
            </div>
        </modal>
        <modal
            closable="true"
            @close="closeEditModal"
            :title="`Update Area`"
            :open="updateModalOpen"
        >
            <div slot="content">
                <form class="space-y-4 mt-4" @submit.prevent="updateArea">
                    <div class="md:flex items-center space-y-2 md:space-y-0 md:space-x-3">
                        <section class="flex-1 space-y-1 flex flex-col">
                            <label for="name" class="text-sm">Area Name (JP)</label>
                            <input
                                placeholder="名前"
                                :disabled="submitting || submitted"
                                v-model="formTag"
                                name="name"
                                class="form-input"
                            />
                        </section>
                        <section class="flex-1 space-y-1 flex flex-col">
                            <label for="nameEn" class="text-sm">Area Name (English)</label>
                            <input
                                placeholder="Health"
                                :disabled="submitting || submitted"
                                v-model="formTagEn"
                                name="nameEn"
                                class="form-input"
                            />
                        </section>
                    </div>
                    <div class="md:flex items-center space-y-2 md:space-y-0 md:space-x-3">
                        <section class="flex-1 space-y-1 flex flex-col">
                            <label for="name" class="text-sm">Category</label>
                            <v-select
                                :disabled="submitting || submitted"
                                class="style-select"
                                v-model="formCategory"
                                :options="categories"
                                placeholder="No Category"
                                label="tag"
                            />
                        </section>
                    </div>
                    <p v-if="!!updateError" class="my-2 error-msg">{{ updateError }}</p>
                    <div class="mt-6 mb-2 flex justify-between">
                        <Button
                            :disabled="updating"
                            @click="closeEditModal"
                            class="bg-gray-200 hover:bg-white hover:border-gray-800 border border-transparent px-6 py-2 rounded"
                            type="button"
                            label="Cancel"
                        />
                        <Button
                            :loading="updating"
                            class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded"
                            label="Update"
                        />
                    </div>
                </form>
            </div>
        </modal>

        <div class="flex-1 flex flex-col items-start">
            <div class="flex-1">
                <span>{{ area.tag }} / {{ area.tagEn }}</span>
            </div>
            <span class="px-3 py-1 bg-indigo-50 rounded-lg leading-none text-xs">{{
                renderCategory(area.category)
            }}</span>
        </div>
        <div class="flex items-center justify-end space-x-2">
            <button
                @click="updateModalOpen = true"
                class="flex items-center text-xs bg-white border border-gray-200 hover:border-gray-600 text-gray-900 px-3 py-px rounded-sm"
            >
                <svg
                    class="w-4 h-4 text-gray-400 mr-1"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    ></path>
                </svg>
                {{ $t('Edit') }}
            </button>
            <button
                @click="deleteModalOpen = true"
                class="flex items-center text-red-600 border-transparent hover:bg-red-600 border hover:border-red-600 hover:text-white text-xs px-3 py-px rounded-sm"
            >
                <svg
                    class="w-4 h-4 group-hover:text-red-100 text-red-100 mr-1"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    ></path>
                </svg>
                {{ $t('Delete') }}
            </button>
        </div>
    </div>
</template>

<script>
import api from '../lib/api'
export default {
    props: ['area', 'categories'],
    methods: {
        closeEditModal() {
            this.updateModalOpen = false
            this.updateError = null
        },
        closeDeleteModal() {
            this.deleteModalOpen = false
            this.deleteError = null
        },
        async deleteArea() {
            this.deleting = true
            try {
                await api.deleteArea(this.area.id)
                this.deleteModalOpen = false
                this.area.deleted = true
            } catch (err) {
                this.deleteError = err.message
            }
            this.deleting = false
        },
        renderCategory(cat) {
            if (!cat) return ''
            //@Todo kinda inefficient , use map lookup instead, but good enough for now
            for (let c of this.categories) {
                if (cat === c.id) return c.tag
            }
            return 'N/A'
        },
        async updateArea() {
            this.updating = true
            try {
                const payload = {
                    tag: this.formTag,
                    tagEn: this.formTagEn,
                }
                if (this.formCategory) {
                    payload.category = this.formCategory.id
                } else {
                    if (this.area.category) {
                        //meaning we removed the category
                        payload.category = null
                    }
                }
                if (payload.category == undefined) {
                    delete payload.category
                }

                try {
                    await api.updateArea(this.area.id, payload)
                    this.updateModalOpen = false
                    this.area.tag = payload.tag
                    this.area.tagEn = payload.tagEn
                    if (payload.category != undefined) this.area.category = payload.category
                } catch (err) {
                    this.formError = err.message
                }
                this.updating = false
            } catch (err) {
                this.updateError = err.message
            }
        },
    },
    data() {
        return {
            formTag: this.area.tag,
            formTagEn: this.area.tagEn,
            formCategory: this.area.category,
            updateError: null,
            updating: false,
            deleteError: null,
            deleting: false,
            submitting: false,
            submitted: false,
            updateModalOpen: false,
            deleteModalOpen: false,
        }
    },
}
</script>
